import { useState, useEffect } from 'react';
import { UserInfo, Employee } from '../types';
import { authService } from '../services/auth';

export function useAuth() {
  const [userInfo, setUserInfo] = useState<UserInfo>({ clientPrincipal: null });
  const [employee, setEmployee] = useState<Employee | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadUserInfo = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Get user info with employee matching from auth service
        const userInfo = await authService.getUserInfoWithEmployee();
        setUserInfo(userInfo);

        // Check if user is authenticated and has an employee record
        if (authService.isAuthenticated(userInfo)) {
          if (userInfo.employee) {
            setEmployee(userInfo.employee);
          } else {
            setError('No employee record found for this email address. Please contact your administrator.');
          }
        }
      } catch (err) {
        console.error('Auth error:', err);
        setError('Failed to authenticate user.');
      } finally {
        setLoading(false);
      }
    };

    loadUserInfo();
  }, []);

  const login = (provider: 'github' | 'google' | 'facebook' | 'twitter' = 'github') => {
    authService.login(provider);
  };

  const logout = () => {
    authService.logout();
  };

  return {
    userInfo,
    employee,
    isAuthenticated: authService.isAuthenticated(userInfo),
    loading,
    error,
    login,
    logout,
    email: authService.getUserEmail(userInfo),
    userId: authService.getUserId(userInfo),
    identityProvider: authService.getIdentityProvider(userInfo)
  };
}
